import { OptionsObject, SharedProps, SnackbarKey, SnackbarMessage } from 'notistack'

export const ENQUEUE_NOTIFICATION = 'ENQUEUE_NOTIFICATION'
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
import { datadogLogs } from '@datadog/browser-logs'

export interface NotificationPayload extends OptionsObject, SharedProps {
  message: SnackbarMessage
}

/**
 * Declared as aliases rather than interfaces: only an alias of an object type carries the
 * implicit index signature redux's `UnknownAction` requires at every `dispatch` call.
 */
export type EnqueueNotificationAction = {
  type: typeof ENQUEUE_NOTIFICATION
  notification: NotificationPayload & { key: SnackbarKey }
}

type CloseNotificationAction = {
  type: typeof CLOSE_NOTIFICATION
  key?: SnackbarKey
  dismissAll?: boolean
}

type RemoveNotificationAction = {
  type: typeof REMOVE_NOTIFICATION
  key: SnackbarKey
}

export type NotificationsAction =
  EnqueueNotificationAction | CloseNotificationAction | RemoveNotificationAction

export const queueNotification = (notification: NotificationPayload): EnqueueNotificationAction => {
  const { message, ...payload } = notification

  if (payload.variant == 'error') {
    try {
      // `SnackbarMessage` allows a ReactNode, which would stringify to '[object Object]';
      // the notification object carries the real content either way.
      datadogLogs.logger.error(
        typeof message === 'string' ? `Error notification: ${message}` : 'Error notification',
        notification,
      )
    } catch (e) {
      // eslint-disable-next-line no-console -- the logger reports through Datadog, which is what just failed
      console.error(e)
    }
  }

  return {
    type: ENQUEUE_NOTIFICATION,
    notification: {
      message,
      ...payload,
      key: payload?.key ?? new Date().getTime() + Math.random(),
    },
  }
}

export const removeNotification = (key: SnackbarKey): RemoveNotificationAction => ({
  type: REMOVE_NOTIFICATION,
  key,
})
